import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaWhatsapp, FaCalendarAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';

const CTA = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-white blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 rounded-full bg-white blur-3xl"></div>
        </div>
      </div>

      <div className="relative container-padding">
        <div className="text-center text-white">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-6"
          >
            Start Your Visa Journey Today
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-xl text-primary-100 max-w-3xl mx-auto mb-12"
          >
            Get expert guidance for your visa application. 
            Our team of specialists is ready to help you achieve your travel or immigration goals.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12"
          >
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition">
              <div className="w-12 h-12 mx-auto mb-4 bg-white rounded-full flex items-center justify-center text-primary-600">
                <FaPhone className="text-xl" />
              </div>
              <h3 className="text-xl font-bold mb-2">Call Us</h3>
              <p className="text-primary-200 mb-4">Speak directly with an expert</p>
              <a href="tel:+15551234567" className="text-white font-bold text-lg hover:text-primary-200 transition">
                0313-5993810
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition">
              <div className="w-12 h-12 mx-auto mb-4 bg-white rounded-full flex items-center justify-center text-primary-600">
                <FaWhatsapp className="text-xl" />
              </div>
              <h3 className="text-xl font-bold mb-2">WhatsApp</h3>
              <p className="text-primary-200 mb-4">Quick chat for instant help</p>
              <a href="https://wa.me/3135993810" className="text-white font-bold text-lg hover:text-primary-200 transition">
                Message on WhatsApp
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/20 transition">
              <div className="w-12 h-12 mx-auto mb-4 bg-white rounded-full flex items-center justify-center text-primary-600">
                <FaCalendarAlt className="text-xl" />
              </div>
              <h3 className="text-xl font-bold mb-2">Book Online</h3>
              <p className="text-primary-200 mb-4">Schedule a consultation</p>
              <Link to="/contact" className="text-white font-bold text-lg hover:text-primary-200 transition">
                Book Free Session
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link
              to="/contact"
              className="btn-primary bg-white text-primary-700 hover:bg-primary-100 px-8 py-4 text-lg"
            >
              Get Free Visa Assessment
            </Link>
            <Link
              to="/services"
              className="btn-secondary border-white text-white hover:bg-white/10 px-8 py-4 text-lg"
            >
              Browse Our Services
            </Link>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="mt-8 text-primary-200"
          >
            No commitment required for initial consultation
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default CTA;